<template>
  <div>
    <section id="content">
      <div class="container">
        <br />

        <!-- NEW COMPONENT HERE -->
        <input
          type="text"
          class="input is-medium has-text-centered"
          style="margin: 0 1rem;"
          v-model="secure"
          placeholder="Enter Type"
          v-if="secure != 'copae-food'"
        />
        <br />
        <div class="filter is-mobile has-text-centered" v-if="secure == 'copae-food'">
          <h2>Search Form</h2>

          <div class="field">
            <p class="control" style="display: flex;">
              <input
                type="text"
                class="input is-medium"
                style="margin: 0 1rem;"
                v-model="startDate"
                @change="submit"
                placeholder="Enter Start Date"
              />
              <input
                type="text"
                class="input is-medium"
                style="margin: 0 1rem;"
                v-model="endDate"
                @change="submit"
                placeholder="Enter End Date"
              />

            </p>
          </div>
        </div>

        <div class="summary" v-if="secure == 'copae-food'">
          <small class="rowCount">
            Showing
            <b>{{ items.length }}</b> records
            <template>
              <label>
                between
                <strong>{{ startDate }} and {{ endDate }}</strong>
              </label>
            </template>
          </small>
        </div>

        <table
          id="results-table"
          class="rtable rtable--flip"
          style="display: block !important;"
          v-if="secure == 'copae-food'"
        >
          <thead>
            <tr>
              <th class="date">Checkin Date</th>
              <th class="permit">Site</th>
              <th class="site">Permit #</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="submission in items" :key="submission.id">
              <td>{{ submission.checkinDate }}</td>
              <td>{{ submission.siteName }}</td>
              <td>{{ submission.permit }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";

export default {
  components: {},

  data() {
    return {
      items: [],
      itemCount: 0,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment(new Date()).format("YYYY-MM-DD"),
      today: moment(new Date()).format("YYYY-MM-DD"),
      secure: "",
      //maxAmount: 1000,
      loading: false,
      error: false
    };
  },

  props: {
    index: { default: 0 },

  },

  mounted() {
    // this.getSubmissions();
  },

  computed: {},

  methods: {
    getSubmissions: function() {
      axios
        .get("/api/mobilefoodlogbook", {
          params: {
            start: this.startDate,
            end: this.endDate,
          }
        })
        .then(response => {
          this.items = response.data;
        });
    },

    submit: function() {
      this.getSubmissions();
    }
  }
};
</script>



// WEBPACK FOOTER //
// Modules/MobileFoodVendor/Resources/assets/js/components/FormSubmissionReportMobileFood.vue